const refs = {
  A: null,
  B: null,
};

let cancelTransitionFn = null;
let revertForOverrideFn = null;

export const registerDeckAudio = (side, el) => {
  refs[side] = el;
  if (el) {
    el.preservesPitch = true;
    el.mozPreservesPitch = true;
    el.webkitPreservesPitch = true;
  }
};

export const setDeckRate = (side, rate) => {
  const el = refs[side];
  if (el) el.playbackRate = rate;
};

export const resetDeckRate = (side) => {
  const el = refs[side];
  if (el) el.playbackRate = 1;
};

export const getDeckAudio = (side) => refs[side];

export const registerCancelTransition = (fn) => {
  cancelTransitionFn = fn;
};

export const registerRevertForOverride = (fn) => {
  revertForOverrideFn = fn;
};

export const revertForOverride = () => {
  if (revertForOverrideFn) revertForOverrideFn();
};

const isAnyPlaying = () =>
  (refs.A && !refs.A.paused) || (refs.B && !refs.B.paused);

export const activeSide = (crossfade) => (crossfade < 0.5 ? "A" : "B");
export const activeAudio = (crossfade) => refs[activeSide(crossfade)];

export const pauseAll = () => {
  if (refs.A && !refs.A.paused) refs.A.pause();
  if (refs.B && !refs.B.paused) refs.B.pause();
};

export const pauseAllAndCancel = () => {
  pauseAll();
  if (cancelTransitionFn) cancelTransitionFn();
};

export const togglePlayPause = (crossfade) => {
  if (isAnyPlaying()) {
    pauseAll();
  } else {
    const el = activeAudio(crossfade);
    if (el) el.play().catch(() => {});
  }
};

export const seekActive = (crossfade, timeSeconds) => {
  const el = activeAudio(crossfade);
  if (el) el.currentTime = timeSeconds;
};
